import React, { Component } from 'react';
import './style.css';
import LoadingIcon from "../LoadingIcon";
import DefaultFilter from "./components/DefaultFilter";

/**

Table config

    columns=[
        {
            name:"Column Header",
            accessor:String|function( rowData, index)//"Property to show from objects in data array",
            headerClass:"A CSS Class",
            rowClass:"A CSS Class",
            filterable:"A boolean, if true a text input appears by clicking the filter icon",
            id:"string to use when filtering",
            filterComponent: Component
        }
    ]
    data=[],//Array to show
    loadData=function( tableState ),//Function called when new data should be fetched, tableState is like {page, pageSize, filters[]}
    trProps=function( row ), //Function called to create the props sent to each row ( specially useful for an onClick on a row )
    paginated= false,
    pageSizes: [10, 15, 25],
    defaultPageSize: 10,
    hover: true,
    totalItems:0,
    noDataText:'No se encontraron registros.',
 */
export default class Table extends Component {

    static defaultProps = {
        columns: [],
        data: [],
        paginated: false,
        pageSizes: [10, 15, 25, 50, 100, 200, 500, 1000, 2000, 4000],
        defaultPageSize: 10,
        hover: true,
        totalItems: 0,
        noDataText: 'No se encontraron registros.',
    };

    constructor(props) {
        super(props);
        this.state = {
            pageSize: props.defaultPageSize,
            page: 0,
            filters: {}
        }
    }

    componentDidMount() {

        if (this.loadData)
            this.loadData(this.state);

    }

    onPageSizeChange(pageSize) {

        const tableState = Object.assign({}, this.state, { pageSize });
        const pages = Math.ceil(this.props.totalItems / this.state.pageSize);

        if (pages - 1 < this.state.page)
            tableState.page = pages - 1;


        this.setState(tableState);
        this.loadData(tableState);

    }

    onPageChange(page) {

        const tableState = Object.assign({}, this.state, { page });
        this.setState(tableState);
        this.loadData(tableState);

    }

    toggleFilter = (name) => {
        if (!name) {
            console.error("The table requires a column id to make it fiterable");
            return;
        }

        const filters = { ...this.state.filters };

        if (filters[name] !== undefined) {
            delete filters[name];
            this.loadData({ ...this.state, filters });
        }
        else {
            filters[name] = "";
        }

        this.setState({ filters });
    };

    updateFilter = (name, value) => {

        let filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({ filters });

        this.loadData({ ...this.state, filters });
    };

    renderFilter = (col) => {

        if (!col.filterable || !col.id || this.state.filters[col.id] === undefined)
            return null;

        const Filter = col.filterComponent || DefaultFilter;

        return <Filter onChange={(value) => this.updateFilter(col.id, value)} value={this.state.filters[col.id]} />;
    };

    loadData = (tableState) => {

        tableState = { ...tableState };
        const filters = tableState.filters;

        if (filters) {
            //Remove filters with empty strings
            tableState.filters = Object.keys(tableState.filters).reduce((acc, key) => {
                if (tableState.filters[key] !== '') {
                    acc[key] = tableState.filters[key];
                }
                return acc;
            },
                {});
        }

        this.props.loadData(tableState);

    };

    render() {

        const rowId = this.props.rowIdAccessor;

        let pages = 0;
        let visiblePages = [];
        let actualPage = this.state.page;

        if (this.props.totalItems) {
            pages = Math.ceil(this.props.totalItems / this.state.pageSize);
            if (pages === 1)
                visiblePages = [0];
            else if (pages === 2)
                visiblePages = [0, 1];
            else if (pages === 3 || this.state.page === 0)
                visiblePages = [0, 1, 2];
            else if (this.state.page === pages - 1)
                visiblePages = [this.state.page - 2, this.state.page - 1, this.state.page];
            else
                visiblePages = [this.state.page - 1, this.state.page, this.state.page + 1];
        }

        const trProps = this.props.trProps;

        return (
            <div className='Table' style={{ overflow: 'auto' }}>

                <table className={'table ' + (this.props.hover ? 'table-hover' : '')}>
                    <thead>
                        <tr>
                            {this.props.columns.map((col, i) =>
                                <th className={col.headerClass ? col.headerClass : ""} key={i}>
                                    {col.name}&nbsp;
                                {col.filterable ? <i className='ti-filter filter-icon'
                                        onClick={() => this.toggleFilter(col.id)} /> : null} <br />
                                    {this.renderFilter(col)}
                                </th>
                            )}

                        </tr>
                    </thead>
                    <tbody>
                        {this.props.data.map((row, i) =>

                            <tr key={rowId ? row[rowId] : i} {...(trProps ? trProps(row, i) : {})}>
                                {this.props.columns.map((col, j) =>
                                    <td className={col.rowClass ? col.rowClass : ""} key={j} data-title={col.name} >
                                        {typeof col.accessor === 'function' ?
                                            col.accessor(row, i)
                                            : row[col.accessor]}
                                    </td>
                                )}
                            </tr>

                        )}

                    </tbody>
                </table>

                {this.props.loading ?
                    <div className='text-center'><LoadingIcon /></div> : null}

                {!this.props.loading && this.props.data.length === 0 ?
                    <p className='no-data'>{this.props.noDataText}</p> : null}

                {/* Start pagination block */}
                {this.props.paginated && this.props.totalItems ?
                    <div className="fixed-table-pagination">

                        <div className="pull-left pagination-detail">
                            <span className="pagination-success" />
                            <span className="page-list">
                                <span className="btn-group dropup">
                                    <button type="button" className="btn btn-success btn-fill  dropdown-toggle" data-toggle="dropdown">
                                        <span className="page-size">{this.state.pageSize}</span> <span className="caret" />
                                    </button>
                                    <ul className="dropdown-menu" role="menu">
                                        {this.props.pageSizes.map((size) =>
                                            <li className={this.state.pageSize === size ? 'active' : ''} key={size}>
                                                <a onClick={() => this.onPageSizeChange(size)}> {size} </a>
                                            </li>
                                        )}
                                    </ul>
                                </span> Filas
                        </span>
                        </div>

                        {visiblePages.length ?
                            <div className="pull-right pagination">
                                <ul className="pagination pagination-success">
                                    {pages > 2 ?
                                        <li className={"page-first " + (actualPage === 0 ? 'disabled' : '')}>
                                            <a onClick={() => this.onPageChange(0)}>
                                                <i className="fa fa-angle-double-left" aria-hidden="true" />
                                            </a>
                                        </li> : null}
                                    {pages > 1 ?
                                        <li className={"page-pre " + (actualPage === 0 ? 'disabled' : '')}>
                                            <a onClick={() => this.onPageChange(actualPage - 1)}>‹</a>
                                        </li> : null}
                                    {visiblePages.map((page) =>
                                        <li className={"page-number " + (actualPage === page ? 'active' : '')} key={page}>
                                            <a onClick={() => this.onPageChange(page)}>{page + 1}</a>
                                        </li>
                                    )}
                                    {pages > 1 ?
                                        <li className={"page-next " + (actualPage === pages - 1 ? 'disabled' : '')}>
                                            <a onClick={() => this.onPageChange(actualPage + 1)}>›</a>
                                        </li> : null}
                                    {pages > 2 ?
                                        <li className={"page-last " + (actualPage === pages - 1 ? 'disabled' : '')}>
                                            <a onClick={() => this.onPageChange(pages - 1)} >
                                                <i className="fa fa-angle-double-right" aria-hidden="true" />
                                            </a>
                                        </li> : null}
                                </ul>
                            </div> : null}

                        <div className="clearfix" />
                        <p className='found-registers'>{this.props.totalItems} registro{this.props.totalItems !== 1 ? 's' : ''} encontrado{this.props.totalItems !== 1 ? 's' : ''}</p>
                    </div>
                    : null}
                {/* End pagination block */}
            </div>
        );
    }

};


// WEBPACK FOOTER //
// ./src/App/components/Table/index.js